<template>
  <div class="auto-reload">
    <div class="btn-group">
      <button 
        class="btn"
        name="autoReloadButton"
        :class="{'green': autoReloadEnabled }"
        @click="toggleAutoReload"
      >
        {{ $t('AUTO_REFRESH') }}
      </button>

      <button
        class="btn"
        :disabled="loading"
        @click="loadData"
      >
        <i 
          class="fa fa-refresh p-r-0"
        />
      </button>
    </div>
  </div>
</template>

<script>
import locales from './locales';
import sharedMessages from '@/core/locales';


export default {
  name: 'AutoReloadData',
  props: {
    autoReloadEnabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    toggleAutoReload() {
      this.$emit('toggleAutoReload', !this.autoReloadEnabled);
    },
    loadData() {
      this.$emit('loadData');
    }
  },
  i18n: {
    locale: 'en',
    messages: locales,
    sharedMessages
  },
};
</script>

<style scoped lang="scss">
.auto-reload {
  display: flex;
  align-items: center;
}
</style>